export default "__VITE_ASSET__2222b341__"